import styled from 'styled-components';
import Theme from '../../Theme';

type Props = {
  variant: 'solid' | 'transparent'
  color?: string
  bgColor?: string
  width?: string
  height?: string
}

const CTAButton = styled.button`
  padding: 15px 45px;
  cursor: pointer;
  border: none;
  outline: none;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 2.5px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
  ${({ variant, bgColor }: Props) => {
    switch (variant) {
      case 'solid':
        return `
          background-color: ${bgColor ? bgColor : Theme.colors.BrandOrange};
        `;
      case 'transparent':
        return `
          background-color: transparent;
          border: 3px solid ${bgColor ? bgColor : Theme.colors.BrandOrange};
        `;
    }
  }}

  color: ${({ color }: Props) => color ? color : Theme.colors.White};
  width: ${({ width }: Props) => width ? width : 'auto'};
  height: ${({ height }: Props) => height ? height : 'auto'};
`;

export default CTAButton;